module.exports = "<div contenteditable=\"true\"  #idtexte (input)=\"aChanger()\"></div>"